import React from 'react';
import ReactDOM from 'react-dom';
import './include/bootstrap.js';
import './custom.css';
import * as serviceWorker from './serviceWorker';
import Analytics from 'react-router-ga';
import App from './App';
import common_en from "./translations/en/common.json";
import common_es from "./translations/es/common.json";
import i18next from 'i18next';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

// Usa debug para ver en consola los mensajes de i18n
// Usa fallbackLng para establecer un idioma por defecto en caso de que no se encuentre el idioma actual
// Si los usas al mismo tiempo no te mostraran las traducciones faltantes

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'es',
  // debug: true,
  fallbackLng: 'es',
  resources: {
    en: {
      common: common_en
    },
    es: {
      common: common_es
    }
  },
});

ReactDOM.render(
  <BrowserRouter>
  
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js